import React from 'react';

// Ширины колонок таблицы «Рейтинг 1.0». Общий colgroup для шапки/боди и вложенной (помесячной)
// таблицы — чтобы колонкам с длинными названиями критериев хватало места и они совпадали по ширине.
const REAL_ESTATE_COLUMN_WIDTH = 180;
const COUNT_COLUMN_WIDTH = 130;
const CRITERIA_COLUMN_WIDTH = 160;

// Фиксированные колонки до критериев: ЖК + 6 показателей (благодарности ×2, жалобы, протоколы, замечания, акты).
const COUNT_COLUMNS = 6;

interface IProps {
  criteriaCount: number;
}

const PartnerRatingColGroup = ({ criteriaCount }: IProps) => (
  <colgroup>
    <col style={{ width: REAL_ESTATE_COLUMN_WIDTH }} />
    {Array.from({ length: COUNT_COLUMNS }).map((_, index) => (
      <col key={`count-${index}`} style={{ width: COUNT_COLUMN_WIDTH }} />
    ))}
    {Array.from({ length: criteriaCount }).map((_, index) => (
      <col key={`criteria-${index}`} style={{ width: CRITERIA_COLUMN_WIDTH }} />
    ))}
  </colgroup>
);

export default PartnerRatingColGroup;
